<template>
    <div>
        <div class="modal fade" id="contact_agent_info_modal" tabindex="-1" aria-labelledby="contactAgentInfoLabel"
            aria-hidden="true" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered contact-agent-info__dialog">
                <div class="modal-content contact-agent-info__modal">
                    <div class="modal-header contact-agent-info__header p-0" :style="[navBarStyle, navBarTextStyle]" >
                        <h5 class="modal-title contact-agent-info__title" id="contactAgentInfoLabel">
                            Informacion de contacto
                            <button type="button" class="btn-close contact-agent-info__close ms-auto" data-bs-dismiss="modal"
                                aria-label="Close"><i class="fas fa-times"></i></button>
                        </h5>
                    </div>
                    <div class="modal-body contact-agent-info__body text-center" :style="navBarTextStyle"
                        style="background: rgba(60,60,60,.95);" >
                        <p class="mb-4">
                            Aqui se mostrara la informacion necesaria para comunicarse con su Agente.
                        </p>
                        <p class="mb-4">
                            Esta informacion le sera util en caso de perder el contacto de su Agente o que el mismo cambie su numero y no tenga forma de avisarle.
                        </p>
                        <p class="mb-4">
                            Debido a que es una funcionalidad nueva en el sitio, su Agente aun no ha configurado esta informacion. Tenga a bien solicitarle que lo haga.
                        </p>
                        <div class="contact-agent-info__footer text-center">
                            <button type="button" class="btn btn-sm contact-agent-info__dismiss" data-bs-dismiss="modal"
                                aria-label="Close">CERRAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "contactAgentInfo",
    props: {
        skin: { type: Object, required: true },
        language: { type: String, default: "es" },
        translation: { type: Object, default: () => ({}) }
    },
    computed: {
        navBarStyle() {
            return this.pickStyle(this.skin?.header_desktop?.nav_bar, ["background", "background-color"]);
        },
        navBarTextStyle() {
            return this.pickStyle(this.skin?.header_desktop?.nav_bar_text, ["color"]);
        }
    },
    methods: {
        pickStyle(style, allowedKeys) {
            if (!style) {
                return {};
            }
            const allowed = new Set(allowedKeys.map((key) => key.toLowerCase()));
            const result = {};
            const assignIfAllowed = (key, value) => {
                const normalizedKey = this.normalizeStyleKey(key);
                if (!allowed.has(normalizedKey)) {
                    return;
                }
                const targetKey = this.styleKeyToCamel(normalizedKey);
                result[targetKey] = value;
            };

            if (typeof style === "string") {
                const output = [];
                style.split(";").forEach((declaration) => {
                    const [rawKey, ...rawValue] = declaration.split(":");
                    if (!rawKey || rawValue.length === 0) {
                        return;
                    }
                    const value = rawValue.join(":").trim();
                    if (!value) {
                        return;
                    }
                    const normalizedKey = this.normalizeStyleKey(rawKey.trim());
                    if (!allowed.has(normalizedKey)) {
                        return;
                    }
                    output.push(`${normalizedKey}: ${value}`);
                });
                return output.length ? `${output.join("; ")};` : {};
            }

            if (Array.isArray(style)) {
                const output = [];
                style.forEach((entry) => {
                    const sanitized = this.pickStyle(entry, allowedKeys);
                    if (!sanitized || (typeof sanitized === "object" && !Array.isArray(sanitized) && !Object.keys(sanitized).length)) {
                        return;
                    }
                    if (Array.isArray(sanitized)) {
                        output.push(...sanitized);
                        return;
                    }
                    output.push(sanitized);
                });
                if (!output.length) {
                    return {};
                }
                return output.length === 1 ? output[0] : output;
            }

            if (typeof style === "object") {
                Object.keys(style).forEach((key) => {
                    const value = style[key];
                    if (value === null || value === undefined || value === "") {
                        return;
                    }
                    assignIfAllowed(key, value);
                });
                return result;
            }

            return result;
        },
        normalizeStyleKey(key) {
            return String(key)
                .trim()
                .replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`)
                .toLowerCase();
        },
        styleKeyToCamel(key) {
            if (key === "background-color") {
                return "backgroundColor";
            }
            return key;
        },
        openModal() {
            const modalEl = document.getElementById("contact_agent_info_modal");
            if (!modalEl) {
                return;
            }
            if (typeof bootstrap !== "undefined" && bootstrap.Modal) {
                const instance = bootstrap.Modal.getOrCreateInstance(modalEl);
                instance.show();
            }
        }
    },
    mounted() {
        this.$root.$on("openContactAgentInfo", this.openModal);
    },
    beforeDestroy() {
        this.$root.$off("openContactAgentInfo", this.openModal);
    }
};
</script>

<style scoped>
.contact-agent-info__modal {
    position: relative;
    margin-top: 1.25rem;
    border-radius: 4px;
    border: none;
    background-color: rgba(60,60,60,.95);
}

.contact-agent-info__dialog {
    max-width: 500px;
}

.contact-agent-info__header {
    display: flex;
    margin-left: 5% !important;
    margin-right: 5% !important;
    margin-top: -1.25rem !important;
    margin-bottom: 0 !important;
    align-items: center;
    height: 60px;
    padding: 0 !important;
    position: relative;
    z-index: 2;
    border-bottom: none;
    color: #fff;
    background: linear-gradient(40deg, #292d3d, #03040d) !important;
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, .18), 0 4px 15px 0 rgba(0, 0, 0, .15);
}

.contact-agent-info__title {
    display: flex;
    width: 100%;
    min-height: 100%;
    align-items: center;
    margin-bottom: 0;
    padding: 16px;
    font-family: Metropolis, sans-serif;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 0.2px;
}

.contact-agent-info__close {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    border: 0;
    background: transparent;
    background-image: none;
    color: #fff !important;
    opacity: 1 !important;
}

.contact-agent-info__close i {
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    color: #fff;
}

.contact-agent-info__body {
    padding: 24px 24px 24px 24px;
    font-family: Metropolis, sans-serif;
    font-size: 16px;
    font-weight: 500;
}

.contact-agent-info__body p {
    line-height: 1.85;
}

.contact-agent-info__footer {
    display: flex;
    justify-content: center;
    margin-top: 16px;
}

.contact-agent-info__dismiss {
    background: #292D3D;
    color: #fff;
    border: 1px solid transparent;
    border-radius: 4px;
    font-family: Metropolis, sans-serif;
    font-weight: 600;
    font-size: 13px;
    margin: 16px 16px 0 16px;
    padding: 13.44px 16px;
    transition: filter 0.2s ease;
}

.contact-agent-info__dismiss:hover {
    filter: brightness(1.1);
}

@media (max-width: 480px) {
    .contact-agent-info__body {
        padding: 26px 18px 18px 18px;
    }
}
</style>
